
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import { YoutubePlayerOptions } from '@/interfaces/components/youtube-player';

import { ClipProvider } from '@/@types/graphql-types';
import TitleClips from '@/components/details/TitleClips.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import type { WebLocale } from '@/enums/web-locale';
import { namespace } from 'vuex-class';

const VideobusterPlayer = () => import('@/ui-components/VideobusterPlayer.vue');
const YoutubePlayerGraphql = () => import('@/ui-components/YoutubePlayerGraphql.vue');
const DailyMotionPlayer = () => import('@/ui-components/DailyMotionPlayer.vue');
const PlexPlayer = () => import('@/ui-components/PlexPlayer.vue');
const VideoPlayerWrapper = () => import('@/ui-components/VideoPlayerWrapper.vue');

const Routing = namespace('routing');
const Language = namespace('language');

@Component({
	name: 'BackdropTrailer',
	components: { YoutubePlayerGraphql, PictureComp, VideobusterPlayer, VideoPlayerWrapper },
})
export default class BackdropTrailer extends Mixins(TitleClips) {
	isMounted = false;

	@Prop({ default: false }) titleName: string;
	@Prop({ type: String, default: '' }) imageUrl: string;
	@Prop({ type: Boolean, default: false }) isTrailerPlaying: boolean;
	@Prop({ required: false, default: false }) isDisneyPlusOffer: boolean;
	@Prop({ default: false }) appleBackdropShowPlayButton: boolean;

	@Routing.State activeRoute: any;

	@Language.State webLocale: WebLocale;

	@Watch('isTrailerPlaying')
	onTrailerPlayingChange(isPlaying: boolean) {
		if (!isPlaying) {
			this.$emit('activate', null);
		}
	}

	mounted() {
		this.isMounted = true;
	}

	get playerVars(): YoutubePlayerOptions {
		return {
			autoplay: this.autoplay ? 1 : 0,
			mute: this.mute ? 1 : 0,
		};
	}

	get videoPlayer() {
		const clipsProvider = (this.clips[0]?.provider as ClipProvider | 'PLEX') ?? null;

		if (clipsProvider == ClipProvider.Videobuster) {
			return VideobusterPlayer;
		} else if (clipsProvider == ClipProvider.Dailymotion) {
			return DailyMotionPlayer;
		} else if (clipsProvider == 'PLEX') {
			return PlexPlayer;
		}

		return YoutubePlayerGraphql;
	}

	onActivate(clipId: string | null) {
		// the same trailer can be in the backdrop and clips area
		const id = clipId ? `${this.source}:${clipId}` : null;
		this.$emit('activate', id);
	}
}
